import React from "react";
import ".././App.css";
import MenuCont from "../Menu/MenuCont";
import Periodistas from "../Periodistas/Periodistas";
import About from "../About/About";
import Programas from "../Programas/Programas";
import Productos from "../Productos/Productos";
import Contact from "../Contact/Contact";
export default function Landing() {
  return (
    <div className="landing-page-cont">
      <MenuCont />
      <header className="landing-header">
        <div className="logo-cont">
          <div className="row0gap rotate">
            <p className="logo-corchete1">[</p>
            <p className="logo-cero">0</p>
            <p className="logo-corchete2">]</p>
          </div>
          <div className="title-cont">
            <p className="title">FOJA</p>
            <p className="title red-and-black">CERO</p>
            <p className="title-subtext">PRODUCCIONES</p>
          </div>
        </div>
              <p className="arrow">»</p>
      </header>
<About />
 <Periodistas />
 <Programas />  
 <Productos /> 
 <Contact />
    </div>
  );
}
